import { QueryClient, QueryKey, UseQueryOptions } from "@tanstack/react-query";

export const queryOptionsSingleShot = {
  retry: false,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  staleTime: Infinity,
  gcTime: Infinity,
} satisfies Partial<UseQueryOptions>;

export const invalidateQueryKeys = (
  queryClient: QueryClient,
  ...queryKeys: QueryKey[]
) =>
  Promise.allSettled(
    queryKeys.map((queryKey) =>
      queryClient.invalidateQueries({
        queryKey,
      }),
    ),
  );
